import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the error ticket api
 */
export class ErrorTicketService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getTickets(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/error-tickets' + params);		
		return data;
	}	
	
	async deleteTickets(ids) {
		var ticketIds = {
			ids: ids
		};
		
		var result = await this.makeDELETERequest('/api/resource/error-tickets', ticketIds);		
		return result;
	}

	exportTickets(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/error-tickets/export' + params);
	}
	
};
